import { SecondaryTranslation } from "types";
import { dashboardEn } from "./strings.dashboard.en";

export const dashboardHi: SecondaryTranslation<typeof dashboardEn> = {
  dashboard_OnboardingSubscriptionPage_PayButtonText: "भुगतान",
};
